<template>
	<div>
		<div class="instructions">
			<h2 v-if="!!title" class="type--sans type--m type--b">{{ title }}</h2>
			<p class="message type--serif">{{ computedMessage }}</p>
		</div>

		<div class="form-group is-small" :class="{'has-error' : $v.email.$error}">
			<label for="email" class="label">Email</label>
			<input type="email" name="email" v-model="$v.email.$model" />
			<FormError :error="$v.email.$error" :message="emailError" />
		</div>
	</div>
</template>

<script>
import FormError from "@/components/formfields/FormError"
import { required, email } from "vuelidate/lib/validators"

export default {
	data() {
		return {
			email: "",
			linkSent: false,
		}
	},

	name: "ForgotPassword",

	props: {
		status: {
			type: String,
			default: ""
		},
		message: {
			type: String
		}
	},

	computed: {
		title() {
			let title
			if (this.status === "fail") title = "Oops"
			if (this.status === "success") title = "Thank you"
			return title
		},

		computedMessage() {
			let defaultMessage = "Simply enter your email address below and we’ll send you a link to your email so you can reset it."
			return this.message || defaultMessage
		},

		emailError() {
			let errorMessage = "Invalid input"
			if (!this.$v.email.email) errorMessage = "Please enter a valid email address"
			if (!this.$v.email.required) errorMessage = "Please enter your email address"
			return errorMessage
		},

		payload() {
			return {
				email: this.email,
			}
		},
	},

	components: { FormError },

	validations: {
		email: { required, email },
	},
}
</script>

<style lang="scss" scoped>
.instructions {
	margin-bottom: 1rem;
}
</style>
